"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caprino-bergamasco": {
    "5a2969bf": [{
      "hkey": "ad165658",
      "slug": "formorone-perlupario-careggia",
      "name": "Formorone-Perlupario-Careggia",
      "primary": true,
      "skipSearch": false
    }],
    "formorone": [{
      "hkey": "ad165658",
      "slug": "formorone-perlupario-careggia",
      "name": "Formorone-Perlupario-Careggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "606bd9e4": [{
      "hkey": "ad165658",
      "slug": "formorone-perlupario-careggia",
      "name": "Formorone-Perlupario-Careggia",
      "primary": true,
      "skipSearch": false
    }],
    "perlupario": [{
      "hkey": "ad165658",
      "slug": "formorone-perlupario-careggia",
      "name": "Formorone-Perlupario-Careggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caprino-bergamasco"
    }],
    "79617e3a": [{
      "hkey": "53425f14",
      "slug": "caprino-bergamasco",
      "name": "Caprino Bergamasco",
      "primary": true,
      "skipSearch": false
    }],
    "cava": [{
      "hkey": "53425f14",
      "slug": "caprino-bergamasco",
      "name": "Caprino Bergamasco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "11333c82": [{
      "hkey": "53425f14",
      "slug": "caprino-bergamasco",
      "name": "Caprino Bergamasco",
      "primary": true,
      "skipSearch": false
    }],
    "prato": [{
      "hkey": "53425f14",
      "slug": "caprino-bergamasco",
      "name": "Caprino Bergamasco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;